<template>
<div id="ccMenu" class="fixed-top">

  <header data-bs-theme="dark">
    <nav class="navbar navbar-expand-md navbar-dark fixed-top" style="background: linear-gradient(180deg, #2e313c 0%, #1c1f2a 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
      <div class="container p-0">

        <router-link to="/" class="navbar-brand p-0">
          <img :src='"../../assets/image/logo_sokker.png"' alt="Responsive image" :title='"sokkerduel"' width="180px">
        </router-link>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarCollapse">
          <ul class="navbar-nav me-auto mb-2 mb-md-0 pt-1">
            <li class="nav-item">
              <router-link to="/" class="nav-link text_bold">
                <div class="text_12" v-bind:class="[posicao==0?'text_verde':'text_branco']"> HOME </div>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/home/torneio/0/0" class="nav-link text_bold">
                <div class="text_12" v-bind:class="[posicao==1?'text_verde':'text_branco']"> TORNEIOS </div>
              </router-link>
            </li>
            <li class="nav-item">
              <!-- <router-link to="/turbo" class="nav-link text_bold" v-show="[501, 502, 503].includes(user.id)"> -->
              <router-link to="/turbo/0" class="nav-link text_bold">
                <div class="text_12 text_branco" v-bind:class="[posicao==4?'text_verde':'text_branco']">
                  <img :src='"../../assets/image/raio.svg"' width="18px"> TURBO
                </div>
              </router-link>
            </li>
            <li class="nav-item" v-if="user_logado">
              <router-link to="/meu_torneio" class="nav-link text_bold">
                <div class="text_12" v-bind:class="[posicao==2?'text_verde':'text_branco']"> MEUS TORNEIOS </div>
              </router-link> 
            </li>
            <li class="nav-item">
              <a href="https://sokkerduel.com/como-funciona/" class="nav-link text_branco text_bold text_12" target="_blank"> COMO FUNCIONA </a>
            </li>
            <li class="nav-item ps-2" v-show="tor_acontecendo">
              <router-link to="/acontecendo" class="btn text_11 text_bold" v-bind:class="[posicao==3?'btn-danger':'btn-outline-danger']">
                <img :src='"../../assets/image/ponto.gif"'> TORNEIOS ACONTECENDO
              </router-link>
            </li>
          </ul>

          <ul class="navbar-nav mb-2 mb-md-0 d-flex pt-1" v-if="user_logado">
            <li class="nav-item" style="padding-right: 10px;">

              <router-link to="/conta/resumo" class="text_branco text_bold text_12" style="padding: 0 10px 0 0; text-decoration: none; ">
                <img :src='"../../assets/image/settings_svg.svg"' width="15px" alt="Responsive image" :title='"sokkerduel"'> MINHA CONTA
              </router-link>
              <br>

              <span class="text_12 text_branco p-0" @click="get_user()" style="cursor: pointer;">
                <img :src='"../../assets/image/refresh-svg1.svg"' width="15px" :title='"refresh"'>
                SALDO: R$ {{formatarMoeda(parseFloat(user.balance))}}
              </span>
            </li>

            <li class="nav-item pt-2">
              <router-link to="/conta/deposito" class="btn btn-sm text_11 text_bold p-2" style="border-color: #59b900; color:#59b900;">
                DEPOSITE
              </router-link>
            </li>

            <li class="nav-item">
              <a class="nav-link ps-3 text_12" href="#" @click="sair()">
                <b style="color:red;">Sair</b>
              </a>
            </li>
          </ul>

          <ul class="navbar-nav mb-2 mb-md-0 d-flex" v-else>
            <li class="nav-item pt-1">
              <router-link to="/cadastro" class="nav-link text_branco text_bold text_12"> CADASTRE-SE </router-link>
            </li>
            <li class="nav-item pt-2">
              <router-link to="/login" class="btn btn-outline-success text_11 text_bold" style="border-color: #59b900; color:#59b900;">
                <img :src='"../../assets/image/login_active.svg"' width="15px" alt="Responsive image" :title='"sokkerduel"'> ENTRAR
              </router-link>
            </li>
          </ul>

        </div>

      </div>
    </nav>
  </header>

</div>
</template>

<script>
  import axios from 'axios'
import { RouterLink } from 'vue-router'
  export default {
    props: {
        posicao: 0,
    },
    data() {
        return {
            base_url_api: process.env.BASE_URL_API,
            user: {},
            loading: false,
            errors: [],
            language: 0,
            user_logado: false,
            tor_acontecendo: true,
        };
    },
    created() {
        let a = JSON.parse(localStorage.getItem("user"));
        if (a == null) {
            this.user = {};
        }
        else {
            this.user = a;
            let d = Date.now() - a.time;
            let r = (d / 1000);
            //morre em aproximadamente 2h
            if (Math.round(r / 60, 0) > 115) {
                this.expluse_para_login();
            }
        }
        if (Object.values(this.user).length != 0) {
            this.user_logado = true;
        }
        else {
            this.user_logado = false;
        }
    },
    
    methods: {
        get_user() {
            this.loading = true;
            var header = { 'headers': { 'x-access-token': this.user.access_token, } };
            axios.get(this.base_url_api + 'user', header)
                .then(response => {
                let a = response.data.data;
                this.user.balance = a.balance;
                this.user.balance_convidado = a.balance_convidado;
                localStorage.setItem("user", JSON.stringify(this.user));
                this.loading = false;
            })
                .catch(e => {
                this.expluse_para_login();
            });
        },

        passe_torneio() {
            this.$router.push({ path: '/home/torneio/0', replace: true });
        },

        sair() {
            this.user = {}
            localStorage.removeItem("user")
            this.user_logado = false;
            this.$router.push({ path: '/', replace: true });
        },

    },
    components: { RouterLink }
}

</script>


<style scoped>

#desktop .logo{
  top: 20px;
  position: absolute;
  z-index: 9999;
  width: 180px;
  opacity: 1;
}

</style>


// WEBPACK FOOTER //
// src/components/layout/menu.vue